import { useEffect, useState } from "react";

export function useIsPortrait() {
  const [isPortrait, setIsPortrait] = useState(() =>
    typeof window !== "undefined"
      ? window.matchMedia("(orientation: portrait)").matches
      : false,
  );

  useEffect(() => {
    const mq = window.matchMedia("(orientation: portrait)");
    const handler = () => setIsPortrait(mq.matches);

    // Safari 호환: addEventListener 미지원일 수 있음
    if (mq.addEventListener) mq.addEventListener("change", handler);
    else mq.addListener(handler);

    window.addEventListener("resize", handler);

    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", handler);
      else mq.removeListener(handler);
      window.removeEventListener("resize", handler);
    };
  }, []);

  return isPortrait;
}
